export * from './table.interface';
export * from './cell.interface';
export * from './custom-table-layout.interface';
export * from './table-body.interface';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/table/index.js
// module id = 1187
// module chunks = 4